import cx from "classnames"
import Icon from "src/shared/icons"
import "./CalendarButtons.css"
import { CalendarButtonsProps } from "./CalendarButtons.props"
import { useFormatDate } from "src/shared/hooks/useFormatDate"

const CalendarButtons = ({
    currDay,
    setCurrDay,
    currMonth,
    setCurrMonth,
    currYear,
    setCurrYear,
    monthNames,
    className,
}: CalendarButtonsProps) => {
    const days = new Date(currYear, currMonth + 1, 0).getDate()
    const { nowHotel: currentDate, getHotelDateParts } = useFormatDate()
    // Leer año/mes de "ahora" en la zona del hotel 
    const { year: currentHotelYear, month: currentHotelMonth } = getHotelDateParts(currentDate)

    const disableNextMonth = (currYear + 1) > currentHotelYear && (currMonth + 1) > currentHotelMonth
    const isNextYearDisabled = (currYear + 1) > currentHotelYear

    const isNextDayDisabled = currDay ? (() => {
        const nextDay = new Date(currYear, currMonth, currDay + 1)
        return nextDay > currentDate
    })() : false

    return (
        <div className={cx("calendario-reservaciones__control", className)}>
            <div className="calendario-reservaciones__control-date-month">
                <button
                    className="calendario-reservaciones__control-btn"
                    onClick={() => {
                        if (currMonth <= 0) {
                            setCurrMonth(11)
                        } else {
                            setCurrMonth(currMonth - 1)
                        }
                    }}
                >
                    <Icon name="chevronleft" color="var(--primary)" />
                </button>
                <p>{monthNames[currMonth]}</p>
                <button
                    disabled={disableNextMonth}
                    style={{ cursor: disableNextMonth ? "not-allowed" : "" }}
                    className="calendario-reservaciones__control-btn"
                    onClick={() => {
                        if (currMonth >= 11) {
                            setCurrMonth(0)
                        } else {
                            setCurrMonth(currMonth + 1)
                        }
                    }}
                >
                    <Icon name="chevronRight" color={disableNextMonth ? "var(--placeholder)" : "var(--primary)"} />
                </button>
            </div>
            {currDay && (
                <div className="calendario-reservaciones__control-date-day">
                    <button
                        className="calendario-reservaciones__control-btn"
                        onClick={() => {
                            if (currDay <= 1) {
                                setCurrDay(days)
                            } else {
                                setCurrDay(currDay - 1)
                            }
                        }}
                    >
                        <Icon name="chevronleft" color="var(--primary)" />
                    </button>
                    <p>{currDay}</p>
                    <button
                        disabled={isNextDayDisabled}
                        style={{ cursor: isNextDayDisabled ? "not-allowed" : "" }}
                        className="calendario-reservaciones__control-btn"
                        onClick={() => {
                            if (currDay >= days) {
                                setCurrDay(1)
                            } else {
                                setCurrDay(currDay + 1)
                            }
                        }}
                    >
                        <Icon name="chevronRight" color="var(--primary)" />
                    </button>
                </div>
            )}

            <div className="calendario-reservaciones__control-date-year">
                <button className="calendario-reservaciones__control-btn" onClick={() => setCurrYear(currYear - 1)}>
                    <Icon name="chevronleft" color="var(--primary)" />
                </button>
                <p>{currYear}</p>
                <button className="calendario-reservaciones__control-btn" onClick={() => setCurrYear(currYear + 1)} disabled={isNextYearDisabled}
                    style={{ cursor: isNextYearDisabled ? "not-allowed" : "" }}
                >
                    <Icon name="chevronRight" color={isNextYearDisabled ? "var(--placeholder)" : "var(--primary)"} />
                </button>
            </div>
        </div>
    )
}
export { CalendarButtons }
